import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Output, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Tab } from './tab.interface';
import { TabGroupService } from './service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { trackBy } from '@railmybox/shared/util';

@UntilDestroy()
@Component({
  selector: 'eg-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TabGroupComponent implements OnInit {
  private tabGroupService = inject(TabGroupService);
  private cdr = inject(ChangeDetectorRef);

  @Input() translateLabels = false;
  @Output() tabSelected: BehaviorSubject<Tab | null> = new BehaviorSubject<Tab | null>(null);
  selectedTab: Tab;
  tabs$: Observable<Tab[]>;
  selectedTabId: string;
  trackBy = trackBy;

  constructor() {
    this.tabs$ = this.tabGroupService.tabs$;
  }

  ngOnInit(): void {
    this.tabGroupService.selectedTab$.pipe(untilDestroyed(this)).subscribe({
      next: (tab) => {
        this.selectedTab = tab;
        this.selectedTabId = tab.tabId ? tab.tabId : tab.id;
        this.tabSelected.next(tab);
        this.cdr.markForCheck();
      },
    });
  }

  onTabClick(item: Tab): void {
    if (item?.tabId ? item.tabId === this.selectedTabId : item.id === this.selectedTabId || item.disabled) {
      return;
    }

    this.selectedTabId = item.tabId ? item.tabId : item.id;
    this.tabGroupService.selectTabById(item.tabId ? item.tabId : item.id);
  }
}
